import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminNewsletter() {
  const [subs, setSubs] = useState([]);
  useEffect(() => { (async () => {
    try { const { data } = await api.get("/admin/newsletter"); setSubs(data); } catch {}
  })(); }, []);

  const exportCsv = () => {
    const rows = [["email", "created_at"], ...subs.map((s) => [s.email, s.created_at])];
    const csv = rows.map((r) => r.map((v) => `"${(v || "").replace(/"/g, '""')}"`).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "dabkazari_newsletter.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="admin-newsletter">
      <div className="flex items-baseline justify-between mb-8">
        <div>
          <p className="text-[11px] uppercase tracking-nav text-[#5C1A1B]">Marketing</p>
          <h1 className="font-serif text-4xl">Newsletter subscribers</h1>
        </div>
        <button onClick={exportCsv} className="bg-[#5C1A1B] text-white uppercase tracking-nav text-[11px] px-4 py-2" data-testid="admin-news-export">Export CSV</button>
      </div>
      <div className="bg-white border border-black/5">
        <ul className="divide-y divide-black/5">
          {subs.map((s, i) => (
            <li key={i} className="px-4 py-3 flex items-center justify-between text-sm">
              <span>{s.email}</span>
              <span className="text-[11px] text-[#7A7A7A] font-mono-alt">{s.created_at?.slice(0, 10)}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
